import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

import { Field, reduxForm, SubmissionError } from 'redux-form';

import Section, { SectionHeader, SectionTitle, SectionBody } from 'components/common/Section';
import Button from 'components/common/Button';
import TextField from 'components/fields/TextField';
import FormError from 'components/common/FormError';

import {
  createBusinessChangeCredentials, updateBusinessChangeCredentials,
} from 'redux/modules/business';

const styles = theme => ({
  grid: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
  },
  gridGutter: {
    marginTop: 15,
  },
  button: {
    marginLeft: 20,
  },
  form: {
    width: 468,
    margin: '10px auto',
  },
});

function onSubmit(values, dispatch, props) {
  if (props.initialValues['Client ID'] !== undefined) {
    return new Promise((resolve, reject) => {
      dispatch(updateBusinessChangeCredentials({
        values,
        resolve,
        reject,
      }));
    }).then(res => res,
      (err) => {
        if (err.error) {
          throw new SubmissionError({ _error: err.error });
        }
        throw new SubmissionError(err);
      });
  }
  return new Promise((resolve, reject) => {
    dispatch(createBusinessChangeCredentials({
      values,
      resolve,
      reject,
    }));
  }).then(res => res,
    (err) => {
      if (err.error) {
        throw new SubmissionError({ _error: err.error });
      }
      throw new SubmissionError(err);
    });
}

const BusinessChangeCredentialsForm = ({
  submit,
  reset,
  handleSubmit,
  submitting,
  error,
  classes,
}) => (
  <Section>
    <SectionHeader>
      <SectionTitle>
        Change Credentials
      </SectionTitle>
      <div>
        <Button
          className={classes.button}
          variant="raised"
          onClick={reset}
        >
          Reset
        </Button>
        <Button
          className={classes.button}
          variant="raised"
          color="primary"
          disabled={submitting}
          onClick={submit}
        >
          Save
        </Button>
      </div>
    </SectionHeader>
    <SectionBody>
      <form
        className={classes.form}
        noValidate
        autoComplete="off"
        onSubmit={handleSubmit}
      >
        {error &&
          <Grid
            className={classes.grid}
            container
            spacing={24}
          >
            <Grid
              item
              xs={12}
            >
              <FormError>
                {error}
              </FormError>
            </Grid>
          </Grid>
        }
        <Grid
          className={classes.grid}
          container
          spacing={24}
        >
          <Grid item xs={6}>
            <Field
              id="Client ID"
              name="Client ID"
              label="Client ID"
              component={TextField}
              // validate={[validate.required]}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              id="Client Secret"
              name="Client Secret"
              label="Client Secret"
              component={TextField}
              // validate={[validate.required]}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          className={classes.grid}
          container
          spacing={24}
        >
          <Grid item xs={6}>
            <Field
              id="Billing ID"
              name="Billing ID"
              label="Billing ID"
              component={TextField}
              // validate={[validate.required]}
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              id="Super User ID"
              name="Super User ID"
              label="Super User ID"
              component={TextField}
              // validate={[validate.required]}
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid
          className={classes.grid}
          container
          spacing={24}
        >
          <Grid item xs={6}>
            <Field
              id="Submitter #"
              name="Submitter #"
              label="Submitter #"
              component={TextField}
              // validate={[validate.required]}
              fullWidth
            />
          </Grid>
        </Grid>
      </form>
    </SectionBody>
  </Section>
);

BusinessChangeCredentialsForm.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submit: PropTypes.func.isRequired,
  reset: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
  error: PropTypes.string,
  classes: PropTypes.shape({
    grid: PropTypes.string.isRequired,
    gridGutter: PropTypes.string.isRequired,
    button: PropTypes.string.isRequired,
    form: PropTypes.string.isRequired,
  }).isRequired,
};

BusinessChangeCredentialsForm.defaultProps = {
  error: null,
};

export default reduxForm({
  onSubmit,
  enableReinitialize: true,
})(withStyles(styles)(BusinessChangeCredentialsForm));



// WEBPACK FOOTER //
// ./src/components/settings/BusinessChangeCredentialsForm/BusinessChangeCredentialsForm.js